import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SfxExtendedMenuManager from "src/components/navigation/SfxExtendedMenuManager.vue"
import { useAuthStore } from "src/stores/authStore"
import { MANAGER_MAIN_MENU } from "src/util/constants/configurations"
import { MainMenuType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getExtendedMenuDataManager } from "src/util/functions/entity"
import { MenuDataManager, MenuDataNames } from "src/util/types/dataModels/entityDefinition"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxMainMenuManager',
  props: {
  mainMenuContent: {
    type: Array as PropType<Array<MainMenuType>>,
  },

  // Whatever goes inside that list would appear as disabled in both Main and Extended menu lists
  disableMainMenuContent: Array as PropType<Array<MainMenuType>>,

  disableMainMenu: Boolean,

  hideExtendedMenu: Boolean,

  disableExtendedMenu: Boolean,

  homeButton: { type: Object as PropType<MenuDataManager> },

  activeTab: {
    type: String as PropType<MenuDataNames>,
    default: "home",
  },

  activeExtendedTab: {
    type: String as PropType<MenuDataNames>,
    default: "home",
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { selectedWorkspace } = useAuthStore()
const route = useRoute()
const workspaceId = selectedWorkspace?.id ?? (route.params.workspaceId as string)
const { t } = useI18n()
const homeTab = computed<MenuDataManager>(
  () =>
    props.homeButton ?? {
      name: "home",
      icon: Icons.HOME,
      to: { name: NamedManagerPath.WORKSPACE, params: { workspaceId } },
      label: "Home",
    }
)

const moreMenuTab = {
  name: "more-menu",
  icon: Icons.CHEVRONS_DOWN,
  label: t("sfxNavigation.more"),
}

const tabModel = ref<string | undefined>(homeTab.value.name)
const showExtendedMenu = ref(false)
const extendedMenu = ref<typeof SfxExtendedMenuManager | undefined>(undefined)

const mainMenuContent = computed(() => {
  const content = props.mainMenuContent || MANAGER_MAIN_MENU

  return content.map((item) => {
    const formattedItem = getExtendedMenuDataManager(item, workspaceId)
    if (props.disableMainMenuContent?.includes(item)) {
      formattedItem.disable = true
    }
    return formattedItem
  })
})

const extendedMenuClass = computed(() =>
  showExtendedMenu.value ? "sfx-rotate-dropdown-icon__180" : "sfx-rotate-dropdown-icon__0"
)

//endregion

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_route_tab = _resolveComponent("q-route-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_tabs, {
    modelValue: tabModel.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tabModel).value = $event)),
    class: "float-left bg-white sfx-main-menu-manager",
    "active-color": "none",
    "indicator-color": "transparent"
  }, {
    default: _withCtx(() => [
      (!props.hideExtendedMenu)
        ? _withDirectives((_openBlock(), _createBlock(_component_q_tab, {
            key: 0,
            class: _normalizeClass(["sfx-extended-menu-manager__dropdown", extendedMenuClass.value]),
            name: moreMenuTab.name,
            icon: moreMenuTab.icon,
            disable: props.disableExtendedMenu,
            ripple: false,
            title: moreMenuTab.label
          }, {
            default: _withCtx(() => [
              (!props.hideExtendedMenu && !props.disableExtendedMenu)
                ? (_openBlock(), _createBlock(_component_q_menu, {
                    key: 0,
                    modelValue: showExtendedMenu.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showExtendedMenu).value = $event)),
                    class: "sfx-extended-menu-manager"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(SfxExtendedMenuManager, {
                        "active-extended-tab": __props.activeExtendedTab,
                        ref_key: "extendedMenu",
                        ref: extendedMenu
                      }, null, 8, ["active-extended-tab"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class", "name", "icon", "disable", "title"])), [
            [_directive_ripple]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_q_route_tab, {
        name: homeTab.value.name,
        to: homeTab.value.to,
        icon: homeTab.value.icon,
        ripple: false,
        title: homeTab.value.label,
        class: _normalizeClass({ 'sfx-main-menu-manager-active': __props.activeTab === homeTab.value.name && !__props.disableMainMenu }),
        disable: __props.disableMainMenu
      }, null, 8, ["name", "to", "icon", "title", "class", "disable"]), [
        [_directive_ripple]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainMenuContent.value, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
          (item.externalLink)
            ? _withDirectives((_openBlock(), _createBlock(_component_q_route_tab, {
                key: 0,
                name: item.name,
                href: item.externalLink,
                target: '_blank',
                icon: item.icon,
                disable: item.disable || __props.disableMainMenu,
                ripple: false,
                title: item.label
              }, null, 8, ["name", "href", "icon", "disable", "title"])), [
                [_directive_ripple]
              ])
            : _withDirectives((_openBlock(), _createBlock(_component_q_route_tab, {
                key: 1,
                name: item.name,
                to: item.to,
                icon: item.icon,
                disable: item.disable || __props.disableMainMenu,
                ripple: false,
                title: item.label,
                class: _normalizeClass({ 'sfx-main-menu-manager-active': __props.activeTab === item.name })
              }, null, 8, ["name", "to", "icon", "disable", "title", "class"])), [
                [_directive_ripple]
              ])
        ], 64))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})